import type {PropsWithChildren} from 'react'
import {faTimes} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {addIfClassNames} from '@freckle/educator-entities/ts/common/helpers/classnames'
import {H2} from '@freckle/educator-materials/ts/components/typography'
import {header, closeIcon, centeredStyle, underlinedStyle} from './header.module.scss'

type Props = PropsWithChildren<{
  // Handle close. If included, shows the little "X" at the top corner
  onClickClose?: () => void
  centered?: boolean
  underlined?: boolean
}>

export const Header = ({children, onClickClose, centered, underlined}: Props) => {
  const headerClassName = addIfClassNames([
    [true, header],
    [centered, centeredStyle],
    [underlined, underlinedStyle]
  ])
  return (
    <>
      <H2 className={headerClassName}>{children}</H2>
      {onClickClose !== undefined ? (
        <FontAwesomeIcon className={closeIcon} icon={faTimes} onClick={onClickClose} />
      ) : null}
    </>
  )
}
